export const FETCH_EDITABLE_FLEET_MANAGER_INFO = 'FETCH_EDITABLE_FLEET_MANAGER_INFO'
export const FETCH_EDITABLE_FLEET_MANAGER_INFO_SUCCESS = 'FETCH_EDITABLE_FLEET_MANAGER_INFO_SUCCESS'
export const FETCH_EDITABLE_FLEET_MANAGER_ERROR = 'FETCH_EDITABLE_FLEET_MANAGER_ERROR'
export const SAVE_EDITABLE_FLEET_MANAGER = 'SAVE_EDITABLE_FLEET_MANAGER'
export const CLEAR_EDITABLE_FLEET_MANAGER = 'CLEAR_EDITABLE_FLEET_MANAGER'
export const SET_EDITABLE_FLEET_MANAGER = 'SET_EDITABLE_FLEET_MANAGER'
